

// Generated class OccupationRule_ManagedObject

class OccupationRule_ManagedObject extends MIOManagedObject
{
    
    
}
